// src/services/companyTimezone.js
// -----------------------------------------------------------
// Funzioni di utilità per il fuso orario della compagnia
// -----------------------------------------------------------

import api from "./api"; // istanza Axios con interceptor Bearer

const STORAGE_KEY = "company_timezone";

/**
 * Restituisce la timezone della company dell'utente loggato.
 *
 *  1. Se è già salvata in localStorage ⇒ la ritorna.
 *  2. Altrimenti chiama una sola rotta aperta a tutti gli utenti
 *     autenticati:  GET  /company/me
 *  3. Salva il risultato in cache e lo restituisce.
 *
 * Torna sempre una stringa IANA valida; in caso di errore "UTC".
 */
export async function fetchCompanyTimezone() {
  // Step 1 – cache
  const cached = localStorage.getItem(STORAGE_KEY);
  if (cached) return cached;

  try {
    // Step 2 – un’unica chiamata
    const { data: company } = await api.get("/company/me");
    const tz = company?.timezone || "UTC";

    // Step 3 – cache & return
    localStorage.setItem(STORAGE_KEY, tz);
    return tz;
  } catch (err) {
    console.error("Impossibile caricare il fuso orario della company:", err);
    return "UTC"; // fallback sicuro
  }
}

/**
 * Pulizia esplicita della cache locale (opzionale).
 * Può servire dopo logout o cambio company.
 */
export function clearCompanyTimezoneCache() {
  localStorage.removeItem(STORAGE_KEY);
}
